import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";

import img_icon_addfavorite from "@/Globals/_images/icons/AddFavorite.png";
import img_icon_favorite from "@/Globals/_images/icons/Favorite.png";

interface IDisplayListComponentProps<TItem> {
    items: SearchableItemModelT<TItem>[];
    renderItem: (item: SearchableItemModelT<TItem>) => JSX.Element;
    // To Remove. how to be a searchable
    includeSearchbox: boolean;
    onSelectedItemCallback: (item: SearchableItemModelT<TItem>) => void;
    classForListContainer?: string;
    classForItem?: string;
    noListBorder?: boolean;
    enableFavorite?: boolean;
    classIconItem?: string;
    onFavoriteItemRemoved?: (item: SearchableItemModelT<TItem>) => void;
    onFavoriteItemAdded?: (item: SearchableItemModelT<TItem>) => void;
}

class DisplayListComponentState<TItem> {
    public textSearch: string;
    public selectedItem: DisplayableListItem<TItem>;
    public items: DisplayableListItem<TItem>[];
    public filteredItems: DisplayableListItem<TItem>[];
}

class BaseDisplayListItem<TItem> {
    public isHighlighted: boolean;
    public Id: number;
    public Model: SearchableItemModelT<TItem>;

    constructor(model: SearchableItemModelT<TItem>) {
        this.isHighlighted = false;
        this.Id = sessionStore.newId();
        this.Model = model;
    }
}

class DisplayableListItem<TItem> extends BaseDisplayListItem<TItem> {
    constructor(arg: SearchableItemModelT<TItem>) {
        super(arg);
    }
}

class DisplayListUI<TItem> extends React.Component<IDisplayListComponentProps<TItem>, DisplayListComponentState<TItem>> {
    private fixedMarginScroll: number;
    private listContainerId: string;

    constructor(props: IDisplayListComponentProps<TItem>) {
        super(props);

        this.listContainerId = sessionStore.newId().toString();
        this.fixedMarginScroll = (this.props.includeSearchbox) ? 5 : 50;

        const initialState = new DisplayListComponentState<TItem>();
        initialState.selectedItem = null;
        initialState.textSearch = "";
        initialState.items = [];
        if (this.props.items != null) {
            initialState.items = this.props.items.map(x => new DisplayableListItem(x));
            initialState.filteredItems = this.props.items.map(x => new DisplayableListItem(x));
        }
        this.state = initialState;
    }

    public componentDidUpdate(prevProps: IDisplayListComponentProps<TItem>): void {
        if (this.props.items != prevProps.items) {
            this.mutateState(s => {
                if (this.props.items != null) {
                    s.items = this.props.items.map(x => new DisplayableListItem(x));
                }
            });
            this.refreshFilterItem(this.state.textSearch);
        }
    }

    public render(): JSX.Element {
        let self = this;

        return (
            <div>
                <div id="parent-item" onKeyDown={self.state.items != null ? (e => self.onKeyDownVersion(e, self.state.items[self.indexOfSelectedItem()])) : null}>

                    {(self.props.includeSearchbox) && (
                        <div className="flex-container s" style={{ padding: "8px 5px 0px" }}>
                            <div className="search-field" style={{ width: "100%", maxHeight: "60px" }}>
                                <div className="gf">
                                    <span className="glyphicon glyphicon-search" />
                                </div>
                                <TextboxControl
                                    onMountFocus={true}
                                    debounceMs={400}
                                    value=""
                                    name="text_search_List"
                                    className="fullWidth"
                                    operation={null}
                                    placeholder={cacheStore.GetString("SearchLabel")}
                                    autoComplete="off"
                                    onChange={value => self.refreshFilterItem(value)}
                                    noAutoCompleteStyle={{ width: "100%" }}
                                />
                            </div>
                        </div>
                    )}

                    {(self.state.items && self.state.items.length > 0) && (
                        <div className={self.props.classForListContainer ? self.props.classForListContainer : ""} id={"item-Name-" + self.listContainerId} style={{ overflowY: "auto", border: (!this.props.noListBorder) && "1px solid rgb(214, 209, 209)", marginTop: self.fixedMarginScroll + "px" }}>
                            <div id={"item-Name-sub-" + self.listContainerId} className="pointer">
                                {self.state.items.map((x, i: number) => {
                                    // Mouse selection or Hover background
                                    let selectedClass = "";
                                    if (self.state.selectedItem != null)
                                        selectedClass = (x.Id === self.state.selectedItem.Id) ? " selected" : "";

                                    // Hover for keyboard shortcut cursor Up/Down
                                    let cssStyle: React.CSSProperties = {};
                                    if (x.isHighlighted == true)
                                        cssStyle = { backgroundColor: "#d9e1f2" };

                                    let Id = self.listContainerId + "__a" + i;
                                    return (
                                        <div className={this.props.classForItem + selectedClass} id={Id} key={Id} style={cssStyle}>
                                            {(this.props.enableFavorite && x.Model.isFavorite) && (
                                                <div style={{ "cursor": "pointer" }} onClick={() => self.removeFavoriteOnClick(x)}>
                                                    <img style={{ "height": "14px", marginRight: "5px" }} id={Id + "_favorite"} src={img_icon_favorite} />
                                                </div>
                                            )}
                                            {(this.props.enableFavorite && !x.Model.isFavorite) && (
                                                <div style={{ "cursor": "pointer" }} onClick={() => self.addFavoriteOnClick(x)}>
                                                    <img style={{ "height": "14px", marginRight: "5px" }} id={Id + "_favorite"} src={img_icon_addfavorite} />
                                                </div>
                                            )}

                                            {!IsNullOrWhiteSpace(this.props.classIconItem) &&
                                                <span className={this.props.classIconItem} />
                                            }
                                            <div onClick={() => self.onClick(x)}>
                                                {self.props.renderItem?.(x.Model)}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                    {(self.props.includeSearchbox && self.state.items && self.state.items.length == 0) && (
                        <div className={self.props.classForListContainer ? self.props.classForListContainer : ""} id={"item-Name-" + self.listContainerId} style={{ marginLeft: "10px" }}>
                            {cacheStore.GetString("ListEmptyLabel")}
                        </div>
                    )}
                </div>
            </div>

        );
    }

    private mutateState(mutation: (s: DisplayListComponentState<TItem>) => void, then: () => void = null): void {
        var s = new DisplayListComponentState<TItem>();
        mutation(s);
        this.setState(s, then);
    }

    private refreshFilterItem(value: string): void {
        let self = this;
        if (self.props.includeSearchbox) {
            self.mutateState(s => {
                s.textSearch = value;

                let filteredItems = [];
                if (self.props.items && self.props.items.length > 0) {
                    filteredItems = self.props.items.filterSearch(value, item => item.Value_Searchable).map(x => new DisplayableListItem(x));
                }
                else {
                    filteredItems = self.props.items.map(x => new DisplayableListItem(x));
                }

                s.items = filteredItems;
            });
        }
    }

    private onClick(item: DisplayableListItem<TItem>): void {
        let self = this;
        self.mutateState(
            s => {
                s.selectedItem = item;
                s.items = self.state.items.map(x => {
                    x.isHighlighted = (x.Id == s.selectedItem.Id);
                    return x;
                });
            },
            () => item && self.props.onSelectedItemCallback(item.Model)
        );
    }

    private removeFavoriteOnClick(item: DisplayableListItem<TItem>): void {
        let self = this;
        self.props.onFavoriteItemRemoved(item.Model);
    }

    private addFavoriteOnClick(item: DisplayableListItem<TItem>): void {
        let self = this;
        self.props.onFavoriteItemAdded(item.Model);
    }

    private onKeyDownVersion(e: React.KeyboardEvent, filteredItems: DisplayableListItem<TItem>): void {
        // up
        if (e.keyCode === 38) {
            e.preventDefault();
            this.moveSelectionUpOrDown(true);
        }

        // down
        if (e.keyCode === 40) {
            e.preventDefault();
            this.moveSelectionUpOrDown(false);
        }

        // enter
        if (e.keyCode === 13 && !e.shiftKey) {
            e.preventDefault();
            this.onClick(filteredItems);
        }

        // escape : remove current highlighted ??!! (same as reset to start from index 0)
        if (e.keyCode === 27) {
            this.mutateState(s => {
                s.items = this.state.items.map(x => {
                    x.isHighlighted = false;
                    return x;
                });
            });
        }
    }

    private moveSelectionUpOrDown(IsDirectionUp: boolean): void {
        let self = this;

        if (self.state.items == null)
            return;

        let collection = self.state.items;
        if (collection.length == 0)
            return;

        let idx = self.indexOfSelectedItem();
        if (idx === -1) {
            collection.forEach(x => x.isHighlighted = false);
            collection[IsDirectionUp ? collection.length - 1 : 0].isHighlighted = true;
            self.mutateState(s => s.items = collection, () => self.adjustRoll());
            return;
        }
        // Top or bottom of list
        if ((idx === 0 && IsDirectionUp) || (idx === collection.length - 1 && !IsDirectionUp))
            return;

        collection[idx].isHighlighted = false;
        idx = idx + (IsDirectionUp ? -1 : 1);

        collection[idx].isHighlighted = true;
        self.mutateState(s => s.items = collection, () => self.adjustRoll());
    }

    private indexOfSelectedItem(): number {
        if (this.state.items == null || this.state.items.length == 0)
            return -1;

        for (var i = 0; i < this.state.items.length; i++) {
            var item = this.state.items[i];
            if (item.isHighlighted == true) {
                return i;
            }
        }
        return -1;
    }

    private adjustRoll(): void {
        let idx = this.indexOfSelectedItem();
        if (this.props.items.length < 2)
            return;

        let scrollParent = $("#item-Name-" + this.listContainerId);
        let scrollSubParent = $("#item-Name-sub-" + this.listContainerId);

        let liSelected = $("#" + this.listContainerId + " __a" + idx);
        let firstItem = $("#" + this.listContainerId + " __a" + 0);

        if (scrollParent != null && liSelected != null && firstItem != null) {
            let scrollZoneHeight = scrollParent.height();

            let currentScrollPosition = (scrollParent.position().top + this.fixedMarginScroll + 1) - scrollSubParent.position().top;

            let itemHeight = scrollSubParent.height() / this.props.items.length;
            let itemTopExpectedPositionRelative = itemHeight * (idx);
            let itemBottomExpectedPositionRelative = itemHeight * (idx + 1);

            if (itemTopExpectedPositionRelative < currentScrollPosition) // Item is above scoll position
                scrollParent.scrollTop(itemTopExpectedPositionRelative);
            else if (itemBottomExpectedPositionRelative > (currentScrollPosition + scrollZoneHeight)) // Item is below scroll
                scrollParent.scrollTop(itemBottomExpectedPositionRelative - scrollZoneHeight); // Add the offset to scroll position in order to fully include the last item
        }
    }
}

export { DisplayListUI };
